<template>
  <!-- 通用服务商，选择与添加列表 -->
  <el-dialog
    title="产品列表"
    :visible.sync="dialogOperatorInfo"
    :showDialogOperatorInfo="showDialogOperatorInfo"
    @close="closeOperatorInfoDialog()"
  >
    <!-- 选择服务商 -->
    <div v-show="select_operator_visable">
      <el-table
        :data="operatorDataList"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <!-- 多选 -->
        <el-table-column type="selection" width="55"> </el-table-column>
        <!-- 产品名称 -->
        <el-table-column width="90%" label="产品列表" prop="spu_name">
          <template slot-scope="operator_item">
            <div>
              <div id="spu_avata_area">
                <img
                  style="height: 100%; weight: 100%"
                  :src="operator_item.row.spu_avatar"
                  alt
                  onerror="this.src='https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png'"
                />
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="spu_name">
          <template slot="header" slot-scope="searchProduct">
            <el-input
              v-model="search"
              size="mini"
              @change="searchProduct"
              placeholder="输入关键字搜索"
            />
          </template>
          <template slot-scope="product_title">
            <div>
              <span style="margin-right: 20px">{{
                product_title.row.spu_name
              }}</span>
              <el-tag
                effect="plain"
                style="margin-right: 10px"
                size="mini"
                v-for="(item, index) in product_title.row.dest"
                :key="index"
                >{{ item }}</el-tag
              >
            </div>
            <div
              v-show="product_title.row.operator"
              style="font-size: 0.05rem; color: lightgrey"
            >
              服务商：
              <span style="margin-right: 20px">{{
                product_title.row.operator
              }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- 列表搜索：searchProduct方法未添加 -->
        <el-table-column width="80%" align="right">
          <template slot-scope="selectOperator">
            <el-button
              size="mini"
              @click="
                choiceProduct(selectOperator.$index, selectOperator.row.spu_id)
              "
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 20px">
        <el-button size="mini" type="primary" @click="submitAllSelect"
          >批量提交</el-button
        >
      </div>
    </div>
    <!-- 按钮 -->
  </el-dialog>
</template>

<script>
import Editor from "../common/editor/editorV1";
import upLoad from "../common/other/UpLoad";
export default {
  name: "product_operator",
  components: {
    "editor-area": Editor,
    "up-load": upLoad,
  },
  data() {
    return {
      multipleSelection: [], // 服务商item
      multipleSelectionId: [], // 服务商id
      select_operator_model: 2, // 选择 还是添加
      select_operator_visable: true,
      add_operator_visable: false,
      operatorDataList: [], // 服务商列表数据
      search: "", // 服务商列表搜索
      dialogOperatorInfo: this.showDialogOperatorInfo,
      labelPosition: "right",
      formOperatorInfo: {
        id: "",
        logo: "",
        name: "",
        loc_name: "",
        dest: "",
        address: "",
        manager: "",
        mobile: "",
        introduce: "",
      },
      file_name: "image",
      selectDests: [], // 绑定对应选项的value值目的地
      option: [], // 目的地可选项
      defaultProp: {
        // 联系选择器的属性，比如是否可以多选等
        multiple: true, //是否多选
        checkStrictly: true, // 是否严格的遵守父子节点不互相关联
        label: "loc_name", // 指定选项标签为选项对象的某个属性值
        value: "loc_id", // 指定选项的值为选项对象的某个属性值
        children: "children", // 指定选项的子选项为选项对象的某个属性值
      },
      imageUrl: "", // 绑定后端图片的文件名称
      image_url: "", // 主图链接
    };
  },
  props: {
    showDialogOperatorInfo: { type: Boolean, default: false },
    spu_id: Number,
  },
  watch: {
    showDialogOperatorInfo: {
      immediate: true,
      handler(showDialogOperatorInfo) {
        // console.log(`watch new vlaue:${this.showDialogOperatorInfo}`);
        this.dialogOperatorInfo = this.showDialogOperatorInfo;
      },
    },
  },
  created() {
    this.loadDest();
    // 获取服务商列表
    this.$http.get(`/product/get_product_list?p_no=1&p_size=20`).then((res) => {
      // console.log(res);
      const { data, errno, errmsg } = res.data;
      this.operatorDataList = data;
    });
  },
  methods: {
    closeOperatorInfoDialog() {
      // 关闭的 子传父
      this.$emit("update:showDialogOperatorInfo", false);
      // this.dialogOperatioInfo = false;
    },

    // 确认 选择 某个服务商：id 和index顺序
    choiceProduct(index, item) {
      // console.log(index, item);
      this.$emit("getOperatorId", item);
    },
    // 多选
    handleSelectionChange(val) {
      let item_id_list = [];
      val.forEach((item) => {
        item_id_list.push(item.spu_id);
      });
      this.multipleSelection = val;
      this.multipleSelectionId = item_id_list;
    },
    // 批量提交
    submitAllSelect() {
      this.$emit(
        "getOperatorInfo",
        this.multipleSelectionId,
        this.multipleSelection
      );
    },

    // 上传图片
    getImageURl(value) {
      console.log(value);
      this.formOperatorInfo.imageUrl = value;
    },
    // 提交
    confirmAdditionAdd() {
      // 构建信息
      this.formOperatorInfo.new_dest = this.selectDests;
      this.formOperatorInfo.spu_id = this.spu_id;
      // 添加到数据库
      this.$http
        .post("/product/change_operator_info", this.formOperatorInfo)
        .then((res) => {
          const { errno, errmsg } = res.data;
          if (errno == "0") {
            this.dialogOperatorInfo = false;
            this.$notify({
              title: "成功",
              message: errmsg,
              type: "success",
            });
            // 修改 父组件  信息
            this.$parent.$parent.$parent.getProductINtorduce();
          } else if (errno == "4103") {
            this.$notify({
              title: "警告",
              message: errmsg,
              type: "warning",
            });
          }
        });
    },
    // 取消 关闭对话框
    cancelAdditionForm() {},
    // 获取 目的地信息
    loadDest() {
      this.$http.get("/get_dest_level").then((res) => {
        this.option = res.data.data;
      });
    },
    // 服务商所在的的选择器，当选择时触发
    handleChoice() {},
  },
};
</script>

<style>
#spu_avata_area {
  height: 40px;
  width: 40px;
}
</style>